function resizeImageToCardBack(file) {
  return new Promise((resolve, reject) => {
    const CARD_W = 150;
    const CARD_H = 212;
    const MAX_SIZE = 50000; // 50KB max

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = CARD_W;
        canvas.height = CARD_H;
        const ctx = canvas.getContext('2d');

        // Cover: scale and center-crop to fill card dimensions
        const scale = Math.max(CARD_W / img.width, CARD_H / img.height);
        const sw = CARD_W / scale;
        const sh = CARD_H / scale;
        const sx = (img.width - sw) / 2;
        const sy = (img.height - sh) / 2;

        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, CARD_W, CARD_H);

        // Compress as JPEG, reduce quality if needed
        let quality = 0.8;
        let dataUrl = canvas.toDataURL('image/jpeg', quality);

        while (dataUrl.length > MAX_SIZE && quality > 0.3) {
          quality -= 0.1;
          dataUrl = canvas.toDataURL('image/jpeg', quality);
        }

        resolve(dataUrl);
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export { resizeImageToCardBack };
